export default "__VITE_ASSET__BYmN5jOo__"